module.exports = __webpack_public_path__ + "img/logo-fil-v2.b557dbf9.svg";